import React from 'react';
import '../Styles/Quality_Policy.css';

import SatishDhawanLogo from '../../Asserts/satish.png';
import HighEnergyLogo from '../../Asserts/highenergy.png';
import NPCILLogo from '../../Asserts/npcil.png';
import NDDBLogo from '../../Asserts/national.png';
import BSNLArmyLogo from '../../Asserts/bsnl.jpg';
import KochiMetroLogo from '../../Asserts/kochi.png';

const Quality_Policy = () => {
  const badgeOfHonourData = [
   {
  logo: SatishDhawanLogo,
  description: `Complete internal and external electrification for the PSLV assembly, manufacture and 
integration factory. 
High rise building on the seashore, 
demanding stringent safety standards with wind speeds up to 65kmph.`,
},

    {
  logo: HighEnergyLogo,
  description: `Electrical and mechanical installations spread across 1.6 lakh sq.mtr factory space.
Adhering to stringent defence
project quality standards..`,
},

  {
  logo: NPCILLogo,
  description: `Construction power for an array of substations for the Nuclear Power Plant.
Hostile weather conditions, hilly terrain, and wildlife in the reserved
forest area.`,
},

   {
  logo: NDDBLogo,
  description: `(under execution)
Electrification work at Animal Vaccination
Plant of Indian Immunologicals Limited near
Hyderabad.`,
},

   {
  logo: BSNLArmyLogo,
  description: `Panels for Indian Army's Network of
Spectrum project in collaboration with BSNL.`,
},

    {
      logo: KochiMetroLogo,
      description:
        'Panels for Kochi Metro stations',
    },
  ];

  return (
    <>
      <hr className="divider" />

      {/* Badge of Honour Section */}
      <section className="badge-of-honour-container section-padding">
        <h2 className="section-title">Our Badge of <span className="highlight-orange">Honour</span></h2>

        <div className="client-grid">
          {badgeOfHonourData.map((client, index) => (
            <article key={index} className="client-item">
              <div className="client-logo-box">
                <img
                  src={client.logo}
                  alt={client.title}
                  className="badge-logo-img"
                />
                <div className="client-title-wrap">
                  <p className="client-title">{client.title}</p>
                </div>
              </div>

              <p className="client-description">{client.description}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
};

export default Quality_Policy;
